export default __webpack_public_path__ + "static/media/elevate-gry-2.50240d6a.png";